import React, { useState } from "react";
import {
  Card,
  CardContent,
  CardActions,
  Typography,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";

/**
 * Props:
 * - guide: the raw guide object (has at least { sk, name })
 * - isOwner: boolean (controls which buttons you show/enable, if desired)
 * - onEdit(guideId: string)
 * - onClone(guide: object)
 * - onDelete(guideId: string): Promise/void
 */
const GuideCard = ({ guide, isOwner, onEdit, onClone, onDelete }) => {
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [deleting, setDeleting] = useState(false);

  // Extract the actual guide id from the `sk` field: "GUIDE#{id}"
  const extractGuideId = (g) => g.sk.split("GUIDE#")[1];
  const guideId = extractGuideId(guide);

  const handleDeleteClick = () => setConfirmOpen(true);

  const handleConfirmDelete = async () => {
    try {
      setDeleting(true);
      await onDelete?.(guideId);
    } finally {
      setDeleting(false);
      setConfirmOpen(false);
    }
  };

  return (
    <>
      <Card>
        <CardContent>
          <Typography variant="h6">{guide.name}</Typography>
          <Typography variant="body2">ID: {guideId}</Typography>
        </CardContent>
        <CardActions>
          <Button size="small" onClick={() => onEdit?.(guideId)}>
            Edit
          </Button>
          <Button size="small" onClick={() => onClone?.(guide)}>
            Clone
          </Button>
          <Button size="small" color="error" onClick={handleDeleteClick} disabled={deleting}>
            Delete
          </Button>
        </CardActions>
      </Card>

      <Dialog open={confirmOpen} onClose={() => setConfirmOpen(false)}>
        <DialogTitle>Delete this guide?</DialogTitle>
        <DialogContent>
          <Typography>This action cannot be undone. Are you sure you want to delete “{guide.name}”?</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setConfirmOpen(false)} disabled={deleting}>
            Cancel
          </Button>
          <Button onClick={handleConfirmDelete} color="error" variant="contained" disabled={deleting}>
            {deleting ? "Deleting…" : "Delete"}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default GuideCard;
